import { useCallback } from 'react';
import { useRequest } from '@Hooks';
import { API } from '@Services';
import { ApiErrorObject } from '@Types';

export const useCompleteProject = () => {
  const [fetch, response] = useRequest<null | ApiErrorObject>();

  const completeProject = useCallback(
    (projectId: number) =>
      fetch(API.paths.project_complete(projectId), 'patch', {
        data: null,
      }),
    [fetch],
  );

  return [completeProject, response] as const;
};
